/**
 * Archivos de WappDrive que se volvieron una pantalla de WAPP: quien abre su enlace viejo llega a la pantalla.
 * 257840 = "OFERTA_ACADEMICA_ENERO_2027_TGU_SPS" → Oferta (Esteban, 2026-10-27).
 */
const DOCS_MUDADOS: Record<number, string> = {
	257840: "/scheduleCatalog?vista=oferta"
};

/** La ruta a la que se mudó el archivo, o null. */
export function rutaMudada(id: number | null | undefined): string | null {
	return id ? DOCS_MUDADOS[id] ?? null : null;
}
